var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.sortedUrls),function(url,index){return _c('profile-photo',{key:index,staticClass:"team-profile-photo",style:('left: ' + 10 * index + 'px'),attrs:{"url":url,"clickable":false,"size":"30px"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }